import angular from 'angular';
import uiRouter from 'angular-ui-router';
import apiaccesslogComponent from './apiaccesslog.component';
import apiaccesslogListComponent from './apiaccesslog-list.component';
import apiaccesslogDetailComponent from './apiaccesslog-detail.component';
import apiaccesslogService from './apiaccesslog.service';

let apiaccesslogModule = angular.module('apiaccesslog', [
  uiRouter
])

.service('Apiaccesslog', apiaccesslogService)

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/notification');

  $stateProvider
    .state('apiaccesslog', {
      component: 'apiaccesslog'
    })
    .state('apiaccesslog.list', {
      url: '/apiaccesslog',
      component: 'apiaccesslogList'
    })
    .state('apiaccesslog.create', {
      url: '/apiaccesslog/new',
      component: 'apiaccesslogDetail',
      params: {
      	id: ""
      }
    })
    .state('apiaccesslog.edit', {
      url: '/apiaccesslog/edit',
      component: 'apiaccesslogDetail',
      params: {
        id: ""
      }
    });
})

.component('apiaccesslog', apiaccesslogComponent)
.component('apiaccesslogList', apiaccesslogListComponent)
.component('apiaccesslogDetail', apiaccesslogDetailComponent)

.name;

export default apiaccesslogModule;



// WEBPACK FOOTER //
// ./client/app/components/apiaccesslog/apiaccesslog.js